import React from "react";

const VERSAO_LOCAL = process.env.REACT_APP_VERSION || 'dev-local';

// Hash curto do build no rodapé (debug). Versão completa em hover.

export const BuildHashFooter = () => {
  if (VERSAO_LOCAL === 'dev-local') return null;
  return (
    <div className="text-center text-[10px] text-slate-400 py-2 select-all">
      Tô Alugando · v{VERSAO_LOCAL}
    </div>
  );
};
